
export const CurvePrefixString = '#@Curve@#:';
export const CurveCmdDocSwitch = '#^DocSwitch^#:';
export const CurveCmdADialog = '#^ADialog^#:';
export const CurveCmdAIaction = '#^AIaction^#:';
export const CurveCmdUIConfig = '#^UIConfig^#:';

export const actStrFixing = '報修';
export const actStrSatiSurvey = '滿意';
export const actStrLeaveRoom = 'LeaveRoom';
export const actStrRepairOrder = 'RepairOrder:';

export const CurveMakeCmd = (cmd: string): string => CurvePrefixString + cmd;
export const CurveMakeADialogCmd = (cmd: string): string => CurveMakeCmd(CurveCmdADialog+cmd);
export const CurveMakeAIActionCmd = (cmd: string): string => CurveMakeCmd(CurveCmdAIaction+cmd);
export const CurveMakeUIConfigCmd = (cmd: string): string => CurveMakeCmd(CurveCmdUIConfig+cmd);

export const CurveCmdsVerify = (cmd: string): boolean => {
    if(cmd && cmd.startsWith(CurvePrefixString)) return true;
    return false;
};

export function CurveCmdsGetCmd(cmd: string): string | null {
    const cmdStr = cmd;
    if(CurveCmdsVerify(cmd)) {
        return cmdStr.substring(cmdStr.indexOf(CurvePrefixString)+CurvePrefixString.length);
    }
    return null;
}

export const CurveCommandVerify = (cmd: string, category: string, act: string | null ): boolean => {
    const Dcmd = CurveCmdsGetCmd(cmd);
    if (Dcmd && Dcmd.startsWith(category)) {
        if (act === null) return true;
        const keyWord = Dcmd.substring(Dcmd.indexOf(category)+category.length);
        if (keyWord === act) return true;
        try {
            const obj = JSON.parse(keyWord);
            // eslint-disable-next-line no-prototype-builtins
            if (obj && obj.hasOwnProperty('cmd')) return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};

export const CurveAICommandVerify = (cmd: string, category: string, act: string | null ): boolean => {
    const Dcmd = CurveCmdsGetCmd(cmd);
    if (Dcmd && Dcmd.startsWith(category)) {
        if (act === null) return true;
        const keyWord = Dcmd.substring(Dcmd.indexOf(category)+category.length);
        if (keyWord && keyWord.startsWith(act)) return true;
    }
    return false;
};

export const CurveCmdDialogVerify = (cmd: string, act: string | null ): boolean => CurveCommandVerify(cmd, CurveCmdADialog, act );
export const CurveCmdAIActionVerify = (cmd: string, act: string | null ): boolean => CurveAICommandVerify(cmd, CurveCmdAIaction, act );
export const CurveCmdUIConfigVerify = (cmd: string, act: string | null ): boolean => CurveCommandVerify(cmd, CurveCmdUIConfig, act );

export const CurveGetRepairOrderInfo = (cmd: string) : object|null => {
    try {
        const Info = JSON.parse(cmd.substring(cmd.indexOf(actStrRepairOrder)+actStrRepairOrder.length));
        return Info;
    } catch(e) {
        return null;
    }
};